"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDefined = exports.isNullOrUndefined = void 0;
/**
 * Checks whether a value is null or undefined. If it is not defined, the return type ensures type safety.
 * @param value any value or null or undefined
 * @returns true if `value` is null or undefined, false otherwise.
 */
function isNullOrUndefined(value) {
    return value === null || value === undefined;
}
exports.isNullOrUndefined = isNullOrUndefined;
/**
 * Checks whether a value is defined. If it is defined, the return type ensures type safety.
 * @param value any value or null or undefined
 * @returns true if `value` is defined (not null and not undefined), false otherwise.
 */
function isDefined(value) {
    return !isNullOrUndefined(value);
}
exports.isDefined = isDefined;
//# sourceMappingURL=defined-utils.js.map